var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"Ellipse_744","data-name":"Ellipse 744","cx":"13","cy":"13","r":"13","fill":"#846d3d","key":0}),React.createElement("path",{"id":"Path_1775","data-name":"Path 1775","d":"M590.274,157.288v5.626h-2.516v-5.626h-2.044v-2.327h2.044v-1.774a2.842,2.842,0,0,1,3.041-3.133,12.368,12.368,0,0,1,1.8.157v1.981h-1.014a1.165,1.165,0,0,0-1.313,1.257v1.51h2.233l-.356,2.327Z","transform":"translate(-576.157 -143.485)","fill":"#fff","key":1})]);
}

FacebookIcon.defaultProps = {"id":"Group_2813","data-name":"Group 2813","width":"26","height":"26","viewBox":"0 0 26 26"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
